<template>
<div class="container">
  <div class="logo">
    <img :src="require('@/assets/yindu.jpg')" alt="">
  </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: "logoHome.vue",
  data() {
    return {}
  },
  created() {
    // 延迟 3 秒调用
    // setTimeout(() => {
      this.getUrlAndJump()
    // }, 3000)
  },
  methods: {
    async getUrlAndJump() {
      // 从路由获取 deviceId
      const deviceId = this.$route.query.deviceId || this.$route.params.deviceId

      if (!deviceId) {
        console.error('未获取到 deviceId')
        return
      }

      try {
        const res = await axios.get('https://www.ygspii.cn/psl/user/getDeviceUrl', {
          params: { deviceId }
        })
        console.log(res)
        // 假设接口返回结构类似 { code:200, data:'跳转链接' }
        const url = res.data.message.data
        if (url) {
          window.location.href = url
        }
      } catch (err) {
        console.error('获取链接失败', err)
      }
    }
  }
}
// https://www.ygspii.cn/psl/user/getDeviceUrl?deviceId=8b151957-c9d7-3288-b920-60b325207ebe   // 进入页面 3秒后再调用接口
</script>

<style scoped lang="scss">
.container {
  background-color: #fff;
  height: 100vh;
  width: 100%;
}
.logo {
  width: 100%;
  background-color: #fff;
  img{

    display: block;
    width: 100%;
    /* 左右居中 */
    margin: 0 auto;
    height: 100vh;
    /* 整体往左偏移20px */
    //margin-left: calc(50% - 39% - 35px);
    ////padding-top: 4.5%;
    //padding-bottom: 9%;
  }
}
</style>
